import React, { FC } from 'react';

import { formatFromISO } from 'src/utils/dateTimeConverters';
import { ICdoGraphContainer } from 'src/@infringements/interfaces';
import { BlockHeader, LineGraph, Card } from '@ems/client-design-system';

export const CdoGraphContainer: FC<ICdoGraphContainer> = ({
  scatterData,
  infringementData,
  title,
  time,
  operationData,
  ruleData,
  type,
}) => {
  const hasProfile: boolean =
    operationData && operationData.profile && !!Object.keys(operationData.profile).length;

  return (
    <div className="block">
      <Card>
        <div>
          <BlockHeader
            title={`${title}`}
            cta={
              time && (
                <span className="infringements_time">{formatFromISO(time, 'HH:mm, DDD')}</span>
              )
            }
            loading={!hasProfile}
          />
          {hasProfile ? (
            <LineGraph
              scatterData={scatterData ? scatterData : operationData.profile}
              infringementData={infringementData}
              maxYValue={ruleData.ceilingAltitude}
              type={type}
            />
          ) : (
            <div className="graph--loading" />
          )}
        </div>
      </Card>
    </div>
  );
};
